import React from 'react';
import MenuItem from '@mui/material/MenuItem';
import Divider from '@mui/material/Divider';
import OpenInNewIcon from '../../images/svg/open_in_new.svg';
import BVLogo from '../../images/svg/logo-bv.svg';
import BoatHistoryLogo from '../../images/boathistory-logosmall.png';
import ProgressiveLogo from '../../images/svg/progressive-logo.svg';

const JDPACustomButtonMenu2 = () => (
    <div className="jdpa-custom-menu-mobile">
        <span className={'menu-button-cat'}>Cars</span>
        <MenuItem className="menu-button-item" disableRipple>
            <a className={'menu-button-link'} href="https://www.jdpower.com/cars-for-sale">Cars for Sale</a>
        </MenuItem>
        <MenuItem className="menu-button-item" disableRipple>
            <a className={'menu-button-link'} href="https://www.jdpower.com/sell-my-car-2">Sell My Car</a>
        </MenuItem>
        <MenuItem className="menu-button-item" disableRipple>
            <a className={'menu-button-link'} href="https://www.jdpower.com/quotes">Free Dealer Price Quote</a>
        </MenuItem>
        <Divider className={'menu-divider'} />
        <span className={'menu-button-cat'}>Specialty Vehicles</span>
        <MenuItem className="menu-button-item" disableRipple>
            <a className={'menu-button-link'} href="https://www.jdpower.com/rvs-for-sale">RVs For Sale</a>
        </MenuItem>
        <MenuItem className="menu-button-item" disableRipple>
            <a className={'menu-button-link'} href="https://www.jdpower.com/motorcycles-for-sale">Motorcycles For Sale</a>
        </MenuItem>
        <MenuItem className="menu-button-item" disableRipple>
            <a className={'menu-button-link'} href="https://www.jdpower.com/boats-for-sale">Boats For Sale</a>
        </MenuItem>
    </div>
);

export default JDPACustomButtonMenu2;